export const RANDOM_SIZES = [50, 100, 200, 500] as const;
export type RandomSize = (typeof RANDOM_SIZES)[number];
